import { render, staticRenderFns } from "./DashboardV2Analytics.vue?vue&type=template&id=18dd004c&scoped=true&"
import script from "./DashboardV2Analytics.vue?vue&type=script&lang=js&"
export * from "./DashboardV2Analytics.vue?vue&type=script&lang=js&"
import style0 from "./DashboardV2Analytics.vue?vue&type=style&index=0&id=18dd004c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dd004c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VChip,VDataTable,VProgressCircular})
